import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-training-parameter-template',
  templateUrl: './training-parameter-template.component.html',
  styleUrls: ['./training-parameter-template.component.scss']
})
export class TrainingParameterTemplateComponent implements OnInit {

  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  trainingParameterTemplateDataForGrid: any = [];
  trainingParameterTemplateDataForGridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddRepeatIntervalUnit: any = null;

  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  infoPopupConfig = {
    width: '500px',
    disableClose: true,
    height: 'auto',
    hasBackdrop: true,
    position: { top: '30px' },
  };

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.trainingParameterTemplateDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.trainingParameterTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.trainingParameterTemplateDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.trainingParameterTemplateDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.trainingParameterTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  focusEmpty() {
    console.log();
  }

  getcallMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.trainingParameterTemplateDataForGrid = [];
    const data = {

      gridName: "TRAINING_PARAMETER_TEMPLATE"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "TRAINING_PARAMETER_TEMPLATE_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.trainingParameterTemplateDataForGrid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }


            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];
              const isInvisible = this.columnLists.invisibleColumnarray.includes(currentColumn);
              if (isInvisible) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const gridItem of this.trainingParameterTemplateDataForGrid) {

                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType == 'CHECKBOX') {
                    gridItem[dataType.columnName] = gridItem[dataType.columnName] == "Y";
                  }
                }

              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
              this.pager.totalPages = undefined;
            });
            this.message.gridList = this.trainingParameterTemplateDataForGrid;
            this.collectionSize = this.trainingParameterTemplateDataForGrid.length;
            this.totalPages = Math.ceil(this.trainingParameterTemplateDataForGrid.length / this.itemsPerPage);
            this.DynamicLabelCall();
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  getListOfQaUsersFromUserPrivs: any = [];
  dropDownDataForRepeatIntervalUnit: any = [];
  ngOnInit() {
    this.getcallMethod();
    this.appService.getTmsQAUserList().subscribe((data: any) => {
      this.getListOfQaUsersFromUserPrivs = data.filter((x: any) => x.isActive == 'Y');
      this.selectBoxForQaUsers();
    })

    this.appService.getCodeListsByGroup("REPEAT_INTERVAL_UNIT").subscribe((data: any) => {
      this.dropDownDataForRepeatIntervalUnit = data;
      this.selectBoxForRepeatIntervalUnit();
    })
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.trainingParameterTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.trainingParameterTemplateDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.trainingParameterTemplateDataForGridTemp = this.trainingParameterTemplateDataForGrid;
      this.pager = this.paginationService.getPager(this.trainingParameterTemplateDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.trainingParameterTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.trainingParameterTemplateDataForGrid == undefined) {
        return this.trainingParameterTemplateDataForGrid;
      }
      if (!this.trainingParameterTemplateDataForGrid.length) {
        return this.trainingParameterTemplateDataForGrid;
      }
      if (filter) {
        this.trainingParameterTemplateDataForGridTemp = this.trainingParameterTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.trainingParameterTemplateDataForGridTemp = this.trainingParameterTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.trainingParameterTemplateDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    this.childCheckBoxs = isChecked;

    for (const item of this.trainingParameterTemplateDataForGrid) {
      item.childCheckBoxs = isChecked;
    }
  }
  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.trainingParameterTemplateDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.TEMPLATE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.trainingParameterTemplateDataForGrid.some((list: any) => list.childCheckBoxs);
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  templateName: any;
  templateNameRequiredMsg: any;
  listOfQAUser: any;
  listOfQAUserRequiredMsg: any;
  updateReq: any;
  updateReqMsg: any;
  fieldValidation() {
    this.templateName = document.getElementById('templateName') as HTMLInputElement;
    this.listOfQAUser = document.getElementById('listOfQaUsers') as HTMLInputElement;
    this.updateReq = document.getElementById('update') as HTMLInputElement;
    this.updateReqMsg = document.getElementById('update-required-msg') as HTMLInputElement;
    this.templateNameRequiredMsg = document.getElementById('templateName-required-msg') as HTMLInputElement;
    this.listOfQAUserRequiredMsg = document.getElementById('listOfQAUsers-required-msg') as HTMLInputElement;

    if (this.trainingParameterTemplateFieldData.templateName == "") {
      this.templateName.style.border = '1px solid red';
      this.templateNameRequiredMsg.style.display = 'block';
    } else {
      this.templateName.style.border = '1px solid black';
      this.templateNameRequiredMsg.style.display = 'none';
    }
    if (this.visibleEditButton) {
      if (this.trainingParameterTemplateFieldData.updateReason) {
        this.updateReq.style.border = '1px solid black';
        this.updateReqMsg.style.display = 'none';
      } else {
        this.updateReq.style.border = '1px solid red';
        this.updateReqMsg.style.display = 'block';
      }
    }

    if (this.trainingParameterTemplateFieldData.overdueQaApprovalReqd) {
      if (this.selectedQaUsers.length < 1) {
        this.listOfQAUser.style.border = '1px solid red';
        this.listOfQAUserRequiredMsg.style.display = 'block';
      } else {
        this.listOfQAUser.style.border = '1px solid black';
        this.listOfQAUserRequiredMsg.style.display = 'none';
      }
    }
  }

  onFieldFocusout() {
    if (this.updateReqMsg != undefined) {
      this.updateReq.style.border = 'none';
      this.updateReqMsg.style.display = 'none';
    }
    if (this.templateNameRequiredMsg != undefined) {
      this.templateName.style.border = 'none';
      this.templateNameRequiredMsg.style.display = 'none';
    }
    if (this.deleteFiledValueRequiredMsg != undefined) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }


  trainingParameterTemplateFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  selectedRepeatIntervalUnit: any = null;
  selectedRepeatIntervalUnitDisplayExp: any = null;
  selectedRepeatIntervalUnitValueExp: any = null;
  repeatIntervalUnitDropdown: any = [];

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  selectBoxForRepeatIntervalUnit() {
    for (const item of this.dropDownDataForRepeatIntervalUnit) {
      this.repeatIntervalUnitDropdown = this.repeatIntervalUnitDropdown.concat({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  repeatIntervalUnitTxt: any;
  onRepeatIntervalUnitSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedRepeatIntervalUnitDisplayExp = item.displayExp;
        } else {
          this.selectedRepeatIntervalUnitDisplayExp = null;
        }
      } else {
        this.selectedRepeatIntervalUnitDisplayExp = undefined;
      }
    }
  }
  onRepeatIntervalUnitRemoved(item: any) { }

  selectedQaUsers: any = [];
  qaUsersListDropdown: any = [];
  selectBoxForQaUsers() {
    for (const qaUser of this.getListOfQaUsersFromUserPrivs) {
      this.qaUsersListDropdown = this.qaUsersListDropdown.concat({
        valueExp: qaUser.userId,
        displayExp: qaUser.userName
      });
    }
  }
  @ViewChild('listOfQAUsers') listOfQAUsers: MatSelect;
  isListQaUsersSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'listOfQAUsers') {
      if (this.isListQaUsersSelected) this.listOfQAUsers.options.forEach((item: MatOption) => item.select());
      else this.listOfQAUsers.options.forEach((item: MatOption) => item.deselect());
    }

  }

  listOfQAUsersTxt: any;
  onQAUsersSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedQaUsers = item.valueExp;
      setTimeout(() => { this.isListQaUsersSelected = this.qaUsersListDropdown.length == this.selectedQaUsers.length; })
    }
  }
  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Training Parameter Template";
    this.trainingParameterTemplateFieldData.templateName = '';
    this.trainingParameterTemplateFieldData.dueNDayFromAssigned = null;
    this.trainingParameterTemplateFieldData.remindNDayBeforeDue = null;
    this.trainingParameterTemplateFieldData.remindEveryNDays = null;
    this.trainingParameterTemplateFieldData.escalate = false;
    this.trainingParameterTemplateFieldData.escalateEveryNDays = null;
    this.trainingParameterTemplateFieldData.repeatTraining = false;
    this.trainingParameterTemplateFieldData.repeatInterval = null;
    this.trainingParameterTemplateFieldData.allowedFailedAttempts = null;
    this.trainingParameterTemplateFieldData.allowedFailedAttemptsAfterUnlock = null;
    this.trainingParameterTemplateFieldData.maxAllowedFailedAttempts = null;

    if (this.selectedQaUsers.length != 0) {
      this.selectedQaUsers = [];
    }
    setTimeout(() => { this.isListQaUsersSelected = this.qaUsersListDropdown.length == this.selectedQaUsers.length; })


    if (this.selectedRepeatIntervalUnit) {
      this.selectedRepeatIntervalUnit = null;
    }

    this.trainingParameterTemplateFieldData.dueNDayFromOverdueUnlock = null;
    this.trainingParameterTemplateFieldData.retakeAfterNMinOnFailedAttempt = null;
    this.trainingParameterTemplateFieldData.allowToReviewResults = false;
    this.trainingParameterTemplateFieldData.showAnswersAtReview = false;
    this.trainingParameterTemplateFieldData.overdueRmApprovalReqd = false;
    this.trainingParameterTemplateFieldData.overdueQaApprovalReqd = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  getTmsTrainingParameterTemplateVwData: any = [];
  qaArray: any = [];
  filteredQaUsersValue: any;
  filteredRepeatIntervalUnit: any;
  positionValue: any = 1;
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    console.log(editRowData);
    this.previousData = editRowData;
    this.visibleReasonForUpdateField = true;

    if (editFlag) {
      this.visibleAddButton = false;
      this.visibleEditButton = true;
      this.operationFlag = 'EDIT';
      this.popupDataTitle.title = "Update Training Parameter Template";
    } else {
      this.visibleAddButton = false;
      this.visibleEditButton = false;
      this.popupDataTitle.title = "Info";
    }

    this.appService.getTmsTrainingParameterTemplateVwDetailsByTemplateId(editRowData.TEMPLATE_ID).subscribe((response: any) => {
      this.getTmsTrainingParameterTemplateVwData = response;
      this.trainingParameterTemplateFieldData.templateName = this.getTmsTrainingParameterTemplateVwData.templateName;
      this.trainingParameterTemplateFieldData.dueNDayFromAssigned = this.getTmsTrainingParameterTemplateVwData.dueNDayFromAssigned;
      this.trainingParameterTemplateFieldData.remindNDayBeforeDue = this.getTmsTrainingParameterTemplateVwData.remindNDayBeforeDue;
      this.trainingParameterTemplateFieldData.remindEveryNDays = this.getTmsTrainingParameterTemplateVwData.remindEveryNDays;
      this.trainingParameterTemplateFieldData.escalate = this.getTmsTrainingParameterTemplateVwData.escalate == 'Y';
      this.trainingParameterTemplateFieldData.escalateEveryNDays = this.getTmsTrainingParameterTemplateVwData.escalateEveryNDays;
      this.trainingParameterTemplateFieldData.repeatTraining = this.getTmsTrainingParameterTemplateVwData.repeatTraining == 'Y';
      this.trainingParameterTemplateFieldData.repeatInterval = this.getTmsTrainingParameterTemplateVwData.repeatInterval;
      this.trainingParameterTemplateFieldData.allowedFailedAttempts = this.getTmsTrainingParameterTemplateVwData.allowedFailedAttempts;
      this.trainingParameterTemplateFieldData.allowedFailedAttemptsAfterUnlock = this.getTmsTrainingParameterTemplateVwData.allowedFailedAttemptsAfterUnlock;
      this.trainingParameterTemplateFieldData.maxAllowedFailedAttempts = this.getTmsTrainingParameterTemplateVwData.maxAllowedFailedAttempts;
      this.trainingParameterTemplateFieldData.dueNDayFromOverdueUnlock = this.getTmsTrainingParameterTemplateVwData.dueNDayFromOverdueUnlock;
      this.trainingParameterTemplateFieldData.retakeAfterNMinOnFailedAttempt = this.getTmsTrainingParameterTemplateVwData.retakeAfterNMinOnFailedAttempt;
      this.trainingParameterTemplateFieldData.allowToReviewResults = this.getTmsTrainingParameterTemplateVwData.allowToReviewResults == 'Y';
      this.trainingParameterTemplateFieldData.showAnswersAtReview = this.getTmsTrainingParameterTemplateVwData.showAnswersAtReview == 'Y';
      this.trainingParameterTemplateFieldData.overdueRmApprovalReqd = this.getTmsTrainingParameterTemplateVwData.overdueRmApprovalReqd == 'Y';
      this.trainingParameterTemplateFieldData.overdueQaApprovalReqd = this.getTmsTrainingParameterTemplateVwData.overdueQaApprovalReqd == 'Y';
      this.trainingParameterTemplateFieldData.updateReason = '';


      if (this.getTmsTrainingParameterTemplateVwData.listOfQaUsers) {
        this.selectedQaUsers = this.getTmsTrainingParameterTemplateVwData.listOfQaUsers.split(",").map(Number);
        setTimeout(() => { this.isListQaUsersSelected = this.qaUsersListDropdown.length == this.selectedQaUsers.length; })
      }
      if (this.getTmsTrainingParameterTemplateVwData.repeatIntervalUnit) {
        const matchingRepeatIntervalUnit = this.dropDownDataForRepeatIntervalUnit?.find((item: any) => item.codelistCode == this.getTmsTrainingParameterTemplateVwData.repeatIntervalUnit);
        if (!matchingRepeatIntervalUnit) {
          this.oddRepeatIntervalUnit = this.getTmsTrainingParameterTemplateVwData.repeatIntervalUnit;
          this.repeatIntervalUnitDropdown.push({
            valueExp: this.getTmsTrainingParameterTemplateVwData.repeatIntervalUnit,
            displayExp: this.getTmsTrainingParameterTemplateVwData.repeatIntervalUnit
          })
        }
        this.selectedRepeatIntervalUnit = this.getTmsTrainingParameterTemplateVwData.repeatIntervalUnit;
      } else {
        this.selectedRepeatIntervalUnit = null;
      }

      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshGridData() {
    this.getcallMethod();
  }

  addAndEditFunction(trainingParameterTemplateFieldData: any) {
    this.isProcessing = true;
    if ((this.visibleEditButton && !trainingParameterTemplateFieldData.updateReason) || trainingParameterTemplateFieldData.templateName == "" || this.trainingParameterTemplateFieldData.overdueQaApprovalReqd && this.selectedQaUsers.length < 1) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      this.fieldValidation();
      if (this.operationFlag == 'ADD') {
        trainingParameterTemplateFieldData.templateName = this.trainingParameterTemplateFieldData.templateName;
        trainingParameterTemplateFieldData.dueNDayFromAssigned = this.trainingParameterTemplateFieldData.dueNDayFromAssigned;
        trainingParameterTemplateFieldData.remindNDayBeforeDue = this.trainingParameterTemplateFieldData.remindNDayBeforeDue;
        trainingParameterTemplateFieldData.remindEveryNDays = this.trainingParameterTemplateFieldData.remindEveryNDays;
        trainingParameterTemplateFieldData.escalate = this.trainingParameterTemplateFieldData.escalate ? 'Y' : 'N';
        trainingParameterTemplateFieldData.escalateEveryNDays = this.trainingParameterTemplateFieldData.escalateEveryNDays;
        trainingParameterTemplateFieldData.repeatTraining = this.trainingParameterTemplateFieldData.repeatTraining ? 'Y' : 'N';
        trainingParameterTemplateFieldData.repeatInterval = this.trainingParameterTemplateFieldData.repeatInterval;
        trainingParameterTemplateFieldData.allowedFailedAttempts = this.trainingParameterTemplateFieldData.allowedFailedAttempts;
        trainingParameterTemplateFieldData.allowedFailedAttemptsAfterUnlock = this.trainingParameterTemplateFieldData.allowedFailedAttemptsAfterUnlock;
        trainingParameterTemplateFieldData.maxAllowedFailedAttempts = this.trainingParameterTemplateFieldData.maxAllowedFailedAttempts;
        trainingParameterTemplateFieldData.dueNDayFromOverdueUnlock = this.trainingParameterTemplateFieldData.dueNDayFromOverdueUnlock;
        trainingParameterTemplateFieldData.retakeAfterNMinOnFailedAttempt = this.trainingParameterTemplateFieldData.retakeAfterNMinOnFailedAttempt;
        trainingParameterTemplateFieldData.allowToReviewResults = this.trainingParameterTemplateFieldData.allowToReviewResults ? 'Y' : 'N';
        trainingParameterTemplateFieldData.showAnswersAtReview = this.trainingParameterTemplateFieldData.showAnswersAtReview ? 'Y' : 'N';
        trainingParameterTemplateFieldData.overdueRmApprovalReqd = this.trainingParameterTemplateFieldData.overdueRmApprovalReqd ? 'Y' : 'N';
        trainingParameterTemplateFieldData.overdueQaApprovalReqd = this.trainingParameterTemplateFieldData.overdueQaApprovalReqd ? 'Y' : 'N';
        trainingParameterTemplateFieldData.listOfQaUsers = "";
        if (this.selectedQaUsers.length > 0) {
          trainingParameterTemplateFieldData.listOfQaUsers = this.selectedQaUsers.map(String).join(",")
        }
        if (this.selectedRepeatIntervalUnit) {
          trainingParameterTemplateFieldData.repeatIntervalUnit = this.selectedRepeatIntervalUnit;
        } else {
          trainingParameterTemplateFieldData.repeatIntervalUnit = null;
        }
        this.appService.createTmsTrainingParameterTemplate(this.trainingParameterTemplateFieldData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getcallMethod();
              this.visibleAddAndEditPopup.close();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        delete trainingParameterTemplateFieldData.createdOn;
        delete trainingParameterTemplateFieldData.updatedOn;
        trainingParameterTemplateFieldData.templateId = this.previousData.TEMPLATE_ID;
        trainingParameterTemplateFieldData.showAnswersAtReview = this.trainingParameterTemplateFieldData.showAnswersAtReview ? 'Y' : 'N';
        trainingParameterTemplateFieldData.allowToReviewResults = this.trainingParameterTemplateFieldData.allowToReviewResults ? 'Y' : 'N';
        trainingParameterTemplateFieldData.escalate = this.trainingParameterTemplateFieldData.escalate ? 'Y' : 'N';
        trainingParameterTemplateFieldData.repeatTraining = this.trainingParameterTemplateFieldData.repeatTraining ? 'Y' : 'N';
        trainingParameterTemplateFieldData.overdueRmApprovalReqd = this.trainingParameterTemplateFieldData.overdueRmApprovalReqd ? 'Y' : 'N';
        trainingParameterTemplateFieldData.overdueQaApprovalReqd = this.trainingParameterTemplateFieldData.overdueQaApprovalReqd ? 'Y' : 'N';
        trainingParameterTemplateFieldData.listOfQaUsers = "";
        if (this.selectedQaUsers.length > 0) {
          trainingParameterTemplateFieldData.listOfQaUsers = this.selectedQaUsers.map(String).join(",")
        }
        if (this.selectedRepeatIntervalUnit) {
          trainingParameterTemplateFieldData.repeatIntervalUnit = this.selectedRepeatIntervalUnit;
        } else {
          trainingParameterTemplateFieldData.repeatIntervalUnit = null;
        }

        this.appService.updateTmsTrainingParameterTemplate(this.trainingParameterTemplateFieldData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.getcallMethod();
              this.fieldValidation();
              this.visibleAddAndEditPopup.close();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = true;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteTrainingParameter: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Training Parameter Template";
    this.deleteTrainingParameter = deleteRowData;
    if (this.trainingParameterTemplateFieldData.deleteReason != undefined) {
      this.trainingParameterTemplateFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteTrainingParameterTemplateData: any;
  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {
        templateId: this.deleteTrainingParameter.TEMPLATE_ID,
        templateName: this.deleteTrainingParameter.TEMPLATE_NAME,
        deleteReason: this.trainingParameterTemplateFieldData.deleteReason,
      }
      this.appService.deleteTmsTrainingParameterTemplate(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.getcallMethod();
            this.visibleDeletePopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, notification: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : notification.TEMPLATE_ID;
    this.auditTrail.gridName = 'TRAINING_PARAMETER_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'Training Parameter Template Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Trainings Parameter Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  checkRemindNDays() {
    if (this.trainingParameterTemplateFieldData.remindEveryNDays > this.trainingParameterTemplateFieldData.remindNDayBeforeDue) {
      this.warningMsg = "Reminder every N days  should be less than reminder N before due."
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
    }
  }

  warningMsg: any;
  okInfo() {
    this.visibleInfoPopup.close();
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  DynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }
  onAllowToReviewResultsChange() {
    if (!this.trainingParameterTemplateFieldData.allowToReviewResults) {
      this.trainingParameterTemplateFieldData.showAnswersAtReview = false;
    }
  }

  onEscalateChange() {
    if (!this.trainingParameterTemplateFieldData.escalate) {
      this.trainingParameterTemplateFieldData.escalateEveryNDays = null;
    }
  }

  onRepeatTrainingChange() {
    if (!this.trainingParameterTemplateFieldData.repeatTraining) {
      this.trainingParameterTemplateFieldData.repeatInterval = null;
      this.selectedRepeatIntervalUnit = null;
    }
  }

  onOverdueQaApprovalReqdChange() {
    if (!this.trainingParameterTemplateFieldData.overdueQaApprovalReqd) {
      this.selectedQaUsers = [];
    }
  }
}
